import {
  logoAT,
  logoCE,
  logoDT,
  logoEducEmp,
  logoGOV,
  logoSelo,
  logoTerritorio,
} from "./logosSistemas";
import titulos from "./titleSistema";

const branch = "hlg";

/**
 * @description
 * O default serve para colocar os valores que mais aparecem, para que só precise mudar nos diferentes e diminuir o trabalho braçal.
 * Tome cuidado pois elas serão setadas para todas as opções, você pode mudar manualmente em cada uma para setar diferentes.
 */
const ufsDefaultDefinitions = {
  na: true,
  uf: "RJ",
  isIndicadores: false,
  isSala: false,
  isParceiro: false,
  isAT: false,
  isEducEmp: false,
  isCE: false,
};

/**
 * @description
 * Valores referentes a cada tipo de municipio e suas respectivas definições, você deve colocar aqui somente nos caras que são
 * diferentes. Tente usar o ufsDefaultDefinitions para colocar as opções mais comuns entre eles.
 */
const ufsPorDefinitions = [
  {
    tag: "painel.cidadeempreendedora.com.br",
    uf: "NA",
    banco: "ce-na-hlg",
    env: process.env.VUE_APP_BASE_API_NA,
    isCE: true,
    svg: process.env.VUE_APP_SVG_NA,
    na: true,
  },
  {
    tag: "painel.desenvolvimentoterritorial.com.br",
    uf: "NA",
    banco: "ce-na-hlg",
    env: process.env.VUE_APP_BASE_API_NA,
    isCE: true,
    svg: process.env.VUE_APP_SVG_NA,
    na: true,
  },
  {
    tag: "painel.territoriosempreendedores.com.br",
    uf: "NA",
    banco: "ce-na-hlg",
    env: process.env.VUE_APP_BASE_API_NA,
    isCE: true,
    svg: process.env.VUE_APP_SVG_NA,
    na: true,
  },
  {
    tag: "painel.sistemaselosebrae.com.br",
    isSala: true,
    ufEmail: "na",
    banco: "selo-painel-na",
    env: process.env.VUE_APP_BASE_API_SELO_NA,
    uf: "NA",
    svg: process.env.VUE_APP_SVG_NA,
    na: true,
  },

  {
    tag: `painel-na-hlg.cidadeempreendedora.com.br`,
    uf: "NA",
    banco: "ce-na-hlg",
    env: process.env.VUE_APP_BASE_API_SELO_NA_HLG,
    isCE: true,
    svg: process.env.VUE_APP_SVG_NA,
    na: true,
  },

  {
    tag: `painel-uf-hlg.cidadeempreendedora.com.br`,
    uf: "MS",
    banco: "ce-ms-hlg",
    env: process.env.VUE_APP_BASE_API_SELO_NA_HLG,
    isCE: true,
    svg: process.env.VUE_APP_SVG_MS,
  },

  {
    tag: `painel-uf-hlg.sistemaselosebrae.com.br`,
    uf: "MS",
    banco: "selo-ms-hlg",
    env: process.env.VUE_APP_BASE_API_SELO_NA_HLG,
    isSala: true,
    svg: process.env.VUE_APP_SVG_MS,
  },

  //#region UFs 2025
  ...[
    "rj",
    "al",
    "ac",
    "ms",
    "ma",
    "sp",
    "es",
    "ba",
    "sc",
    "ap",
    "am",
    "ce",
    "go",
    "mt",
    "pa",
    "pb",
    "pr",
    "pe",
    "pi",
    "rn",
    "mg",
    "rs",
    "ro",
    "rr",
    "se",
    "to",
    "df",
  ].flatMap((item) => [
    //#region HLG
    {
      tag: `${item}-hlg.cidadeempreendedora.com.br`,
      banco: `ce-${item}-hlg`,
      uf: item.toUpperCase(),
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },

    {
      tag: `${item}-hlg-parceiros.sistemaselosebrae.com.br`,
      banco: `selo-${item}-hlg-parceiros`,
      uf: item.toUpperCase(),
      isParceiro: true,
      isSala: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    {
      tag: `${item}-hlg.sistemaselosebrae.com.br`,
      banco: `selo-${item}-hlg`,
      uf: item.toUpperCase(),
      isSala: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    {
      tag: `${item}-hlg.empreendedoraeducacao.com.br`,
      banco: `edu-${item}-hlg`,
      uf: item.toUpperCase(),
      isEducEmp: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    {
      tag: `${item}-hlg.selosaladoempreendedor.com.br`,
      banco: `selo-${item}-hlg`,
      uf: item.toUpperCase(),
      isSala: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    {
      tag: `${item}-hlg-parceiros.selosaladoempreendedor.com.br`,
      banco: `selo-${item}-hlg-parceiros`,
      uf: item.toUpperCase(),
      isParceiro: true,
      isSala: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    {
      tag: `${item}-hlg.agentesterritoriais`,
      banco: `agentes-territoriais--${item}-hlg`,
      uf: item.toUpperCase(),
      isAT: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    {
      tag: `${item}-hlg.territoriosempreendedores`,
      banco: `ce-${item}-hlg`,
      uf: item.toUpperCase(),
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
      isAT: true,
    },
    {
      tag: `${item}-hlg.desenvolvimentoterritorial`,
      banco: `ce-${item}-hlg`,
      uf: item.toUpperCase(),
      isDT: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    //#endregion HLG
    //#region PROD
    {
      tag: `${item}.cidadeempreendedora.com.br`,
      banco: `${item}`,
      uf: item.toUpperCase(),
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    {
      tag: `${item}-parceiros.sistemaselosebrae.com.br`,
      banco: `selo-sala-${item}-parceiros`,
      uf: item.toUpperCase(),
      isParceiro: true,
      isSala: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    {
      tag: `${item}.sistemaselosebrae.com.br`,
      banco: `selo-sala-${item}`,
      uf: item.toUpperCase(),
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
      isSala: true,
    },
    {
      tag: `${item}.empreendedoraeducacao.com.br`,
      banco: `edu-${item}`,
      uf: item.toUpperCase(),
      isEducEmp: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    {
      tag: `${item}.selosaladoempreendedor.com.br`,
      banco: `selo-sala-${item}`,
      uf: item.toUpperCase(),
      isSala: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    {
      tag: `${item}-parceiros.selosaladoempreendedor.com.br`,
      banco: `selo-sala-${item}-parceiros`,
      uf: item.toUpperCase(),
      isParceiro: true,
      isSala: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    {
      tag: `${item}.agentesterritoriais`,
      banco: `agentes-territoriais-${item}`,
      uf: item.toUpperCase(),
      isAT: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    {
      tag: `${item}.territoriosempreendedores`,
      banco: `${item}`,
      uf: item.toUpperCase(),
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
      isAT: true,
    },
    {
      tag: `${item}.desenvolvimentoterritorial`,
      banco: `${item}`,
      uf: item.toUpperCase(),
      isDT: true,
      svg: process.env[`VUE_APP_SVG_${item.toUpperCase()}`],
    },
    //#endregion PROD
  ]),
  //#endregion UFs 2025

  {
    tag: "indicadores-sp",
    banco: "cidade-empreendedora-sp-indicadores",
    uf: "SP",
    isIndicadores: true,
  },
  { tag: "indicadores.consorcioempreendedor", banco: "sp", uf: "SP" },

  {
    tag: "localhost",
    banco: "ma",
    uf: "MA",
    svg: process.env.VUE_APP_SVG_MA,
    isSala: false,
    na: false,
    isCE: true,
    isParceiro: false,
  },
];

const ufsDefinitions = ufsPorDefinitions.map((item) => {
  return { ...ufsDefaultDefinitions, ...item };
});

export const EnumAmbienteTipos = {
  prod: "prod",
  dev: "dev",
  hlg: "hlg",
};

let atual;
const hrf = window.location.href;
const ceDevBanco = "ce-dev";
const ceHlgBanco = "ce-hlg";

ufsDefinitions.forEach((item) => {
  if (hrf.includes("sistemaselo") || hrf.includes("selosaladoempreendedor")) {
    if (hrf.includes("parceiros")) {
      item.isParceiro = true;
    }
    item.isSala = true;
  } else if (hrf.includes("agentesterritoriais")) {
    item.isAT = true;
  } else if (hrf.includes("governancaempreendedora")) {
    item.isGov = true;
  } else if (hrf.includes("desenvolvimentoterritorial")) {
    item.isDT = true;
  } else if (hrf.includes("territoriosempreendedores")) {
    item.isTerritorio = true;
  } else if (hrf.includes("empreendedoraeducacao")) {
    item.isEducEmp = true;
  } else if (hrf.includes("cidadeempreendedora")) {
    item.isCE = true;
  }

  if (item.isSala || item.isParceiro) {
    if (!item.title) item.title = titulos.sala;
    if (!item.corPrimaria) item.corPrimaria = "#2a4fd7";
    if (!item.logos) item.logos = logoSelo;
  } else if (item.isAT) {
    if (!item.title) item.title = titulos.at;
    if (!item.logos) item.logos = logoAT;
    if (!item.corPrimaria) item.corPrimaria = "#93CE98";
    if (!item.logo) item.logo = "logo_at_branca.png";
  } else if (item.isGov) {
    if (!item.title) item.title = titulos.gov;
    if (!item.logos) item.logos = logoGOV;
    if (!item.logo) item.logo = "Logo_Governança_Empreendedora-branca.png";
    if (!item.corPrimaria) item.corPrimaria = "#9079A8";
  } else if (item.isDT) {
    if (!item.title) item.title = titulos.dt;
    if (!item.logos) item.logos = logoDT;
    if (!item.corPrimaria) item.corPrimaria = "#000";
  } else if (item.isTerritorio) {
    if (!item.title) item.title = titulos.territorio;
    if (!item.logos) item.logos = logoTerritorio;
    if (!item.corPrimaria) item.corPrimaria = "#000";
  } else if (item.isEducEmp) {
    if (!item.title) item.title = titulos.educEmp;
    if (!item.logos) item.logos = logoEducEmp;
    if (!item.corPrimaria) item.corPrimaria = "#908dc4";
  } else {
    if (!item.logo) item.logo = "logo_nacional.png";
    if (!item.logos) item.logos = logoCE;
    if (!item.title) item.title = titulos.ce;
    if (!item.corPrimaria) item.corPrimaria = "#000";
  }

  if (hrf.includes(item.tag)) {
    // urls com dev no nome
    if (
      item.tag.indexOf("dev") !== -1 ||
      item.tag.indexOf("amazonaws.com") !== -1
    ) {
      console.log(
        "!----------------- AMBIENTE DE DESENVOLVIMENTO -----------------!"
      );
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_SELO_NA_HLG;
      item.ambient = EnumAmbienteTipos.dev;
    }
    // urls com hlg no nome
    else if (item.tag.indexOf("hlg") !== -1) {
      console.log(
        "!----------------- AMBIENTE DE HOMOLOGAÇÃO -----------------!"
      );
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_UF_HLG;
      item.ambient = EnumAmbienteTipos.hlg;
    }
    // urls com localhost no nome
    else if (item.tag.indexOf("localhost") !== -1) {
      console.log(
        "!----------------- AMBIENTE DE DESENVOLVIMENTO LOCAL -----------------!"
      );
      if (!item.banco) item.banco = ceDevBanco;
      item.ambient = EnumAmbienteTipos.dev;
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_LOCAL;
    }
    // produção
    else {
      console.log("!----------------- AMBIENTE DE PRODUÇÃO -----------------!");
      item.ambient = EnumAmbienteTipos.prod;
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_UF;
    }

    atual = { ...item, urlTag: item.tag };
  }
});

export const atualUfDefinition = atual;

window.atualUfDefinition = atualUfDefinition;

/**
 *
 * @param {*} str - Essa string já vem automatica no filtro, não precisa passar
 * @param {*} tipo - cpf | telefone | email | nome
 * @returns
 */
export const esconderPalavras = (str, tipo) => {
  if (str) {
    if (tipo === "cpf") {
      return str.substring(0, 4) + "**" + str.substring(11, 14);
    } else if (tipo === "telefone") {
      return str.substring(0, 4) + "**" + str.substring(8, 11);
    } else if (tipo === "email") {
      const indexOfArroba = str.indexOf("@", 0);
      const indexOfArrobaDivided = parseInt(str.indexOf("@", 0) / 2);
      return (
        str.substring(0, indexOfArrobaDivided) +
        "**" +
        str.substring(indexOfArroba)
      );
    } else if (tipo === "nome") {
      const names = str.split(" ");
      if (names.length > 1) return names[0] + " " + names[names.length - 1];
      return names[0];
    }
  }
  return str;
};

export const sortArrayAsc = (a, b) => {
  if (typeof a === "string" && typeof b === "string") {
    if (
      a.normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
      b.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    ) {
      return -1;
    }
    if (
      a.normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
      b.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    ) {
      return 1;
    }
  } else {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
  }
  return 0;
};

export const isSPHlg = ["sp-hlg.cidadeempreendedora.com.br"].some((host) =>
  window.location.host.startsWith(host)
);

export const isSP = [
  "sp.cidadeempreendedora.com.br",
  "sp.territoriosempreendedores.com.br",
  "sp.desenvolvimentoterritorial.com.br",
].some((host) => window.location.host.startsWith(host));

export const isSPNewUser = () => {
  return isSP && window.spUser && window.spUser.grupoId === 10;
};

export function mobileAndTabletCheck() {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
